<template>
	<div class="quality-summary gray-bar-top app">
		<h3 class="app-title">
			Quality Summary
			<disclosure-superscript
				class="detail-page"
				anchor="qualitySummary"
				:statistics="['qualitySummary']"
			/>
		</h3>
		<read-more />
		<blue-table :module-data="{data: qualityData, includeDataField: true}">
			<template #superscript1>
				<disclosure-superscript
					class="detail-page"
					anchor="qualitySummary_fixedIncomeCash"
					:statistics="['fixedIncomeCash']"
				/>
			</template>
		</blue-table>
		<div class="sub-info adjust-down">% of net assets as of {{ setAsOfDate(qualityData) }} (updated quarterly).</div>
	</div>
</template>
<script>
import ReadMoreLink from '_components_/Shared/ReadMoreLink';
import BlueBarTable from '_components_/global/BlueBarTable';

export default {
	name: 'QualitySummary',
	components: {
		'read-more': ReadMoreLink,
		'blue-table': BlueBarTable
	},
	props: {
		qualityData: {
			type: Array,
			default: null
		}
	},
	watch: {
		qualityData: {
			immediate: true,
			handler(val) {
				this.$EventBus.$emit('ExcelData', 'QualitySummaryModule', val);
			}
		}
	},
	methods: {
		setAsOfDate(array) {
			return array[0] && array[0].DataAsOfDate
				? array[0].DataAsOfDate
				: '--';
		}
	}
};
</script>

<style lang="less" scoped>
.quality-summary {
	color: #333;
	font-family: 'AvenirNextLTW01-Regular', Arial, serif;
	font-size: 14px;
	.list-label-value {
		margin-top: 20px;
	}
	.adjust-down {
		margin-top: 10px;
	}
}
</style>
